import classNames from 'classnames';
import { SVGPropsIcon } from 'src/types';

export const SimpleClose = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      className={classNames('cursor-pointer', props.className)}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none">
      <path
        d="M15.6561 15.66C16.1094 15.2068 16.1094 14.4719 15.6561 14.0186L9.63942 8.00189L15.6599 1.9814C16.1132 1.52813 16.1132 0.793236 15.6599 0.339965C15.2066 -0.113305 14.4717 -0.113304 14.0185 0.339967L7.99798 6.36045L1.97748 0.339953C1.52421 -0.113318 0.789316 -0.113318 0.336046 0.339953C-0.117225 0.793223 -0.117223 1.52812 0.336047 1.98139L6.35654 8.00189L0.339819 14.0186C-0.113451 14.4719 -0.113451 15.2068 0.33982 15.66C0.79309 16.1133 1.52799 16.1133 1.98126 15.66L7.99798 9.64332L14.0147 15.66C14.468 16.1133 15.2029 16.1133 15.6561 15.66Z"
        fill="url(#paint0_linear_18764_84388)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_18764_84388"
          x1="7.99797"
          y1="0"
          x2="7.99797"
          y2="16"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#88E5DC" />
          <stop offset="1" stopColor="#1DCDC3" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const CloseComponentWithoutStyles = ({ onShow, ...props }: SVGPropsIcon) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        onShow?.(e);
      }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}>
      <path
        d="M10.1417 8.00048L14.7822 3.36003C15.2949 2.84731 15.2949 2.01605 14.7822 1.50413L14.1635 0.885503C13.6507 0.372621 12.8194 0.372621 12.3075 0.885503L7.6672 5.5258L3.02674 0.884541C2.51402 0.37182 1.68277 0.37182 1.17085 0.884541L0.551259 1.50317C0.038537 2.01605 0.038537 2.84731 0.551259 3.35923L5.19251 8.00048L0.55222 12.6408C0.0393382 13.1537 0.0393382 13.9849 0.55222 14.4968L1.17085 15.1155C1.68357 15.6282 2.51482 15.6282 3.02674 15.1155L7.6672 10.475L12.3075 15.1155C12.8204 15.6282 13.6516 15.6282 14.1635 15.1155L14.7822 14.4968C15.2949 13.9839 15.2949 13.1527 14.7822 12.6408L10.1417 8.00048Z"
        fill={props?.fill || 'currentColor'}
      />
    </svg>
  );
};

export const BigCloseGame = (props: SVGPropsIcon) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={props.onShow}
      {...props}
      className={classNames('cursor-pointer', props.className)}>
      <path
        d="M4.45005 28.7999C4.2028 28.7999 3.96108 28.7267 3.75547 28.5893C3.54987 28.452 3.38962 28.2567 3.29499 28.0283C3.20036 27.7998 3.17561 27.5485 3.22386 27.306C3.27211 27.0635 3.3912 26.8407 3.56606 26.6659L26.6659 3.56605C26.9004 3.3316 27.2183 3.19989 27.5499 3.19989C27.8815 3.19989 28.1994 3.3316 28.4339 3.56605C28.6683 3.8005 28.8001 4.11848 28.8001 4.45005C28.8001 4.78161 28.6683 5.09959 28.4339 5.33404L5.33405 28.4339C5.21807 28.5501 5.08027 28.6423 4.92857 28.7051C4.77686 28.7679 4.61425 28.8001 4.45005 28.7999Z"
        fill="white"
      />
      <path
        d="M27.5499 28.7999C27.3857 28.8001 27.2231 28.7679 27.0714 28.7051C26.9197 28.6423 26.7819 28.5501 26.6659 28.4339L3.5661 5.33404C3.33165 5.09959 3.19993 4.78161 3.19993 4.45005C3.19993 4.11848 3.33165 3.8005 3.5661 3.56605C3.80055 3.3316 4.11853 3.19989 4.45009 3.19989C4.78165 3.19989 5.09963 3.3316 5.33408 3.56605L28.4339 26.6659C28.6088 26.8407 28.7279 27.0635 28.7761 27.306C28.8244 27.5485 28.7996 27.7998 28.705 28.0283C28.6104 28.2567 28.4501 28.452 28.2445 28.5893C28.0389 28.7267 27.7972 28.7999 27.5499 28.7999Z"
        fill="white"
      />
    </svg>
  );
};

export const Close = (props: SVGPropsIcon) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={props.onClick}
      {...props}>
      <path
        d="M19.5711 19.575C20.1377 19.0084 20.1377 18.0898 19.5711 17.5232L12.0502 10.0023L19.5758 2.47675C20.1424 1.91016 20.1424 0.991543 19.5758 0.424956C19.0092 -0.141631 18.0906 -0.141629 17.524 0.424958L9.99844 7.95055L2.47283 0.42494C1.90624 -0.141647 0.987621 -0.141647 0.421033 0.424941C-0.145554 0.991528 -0.145552 1.91015 0.421035 2.47674L7.94665 10.0023L0.42575 17.5232C-0.140837 18.0898 -0.140837 19.0085 0.42575 19.575C0.992338 20.1416 1.91096 20.1416 2.47755 19.575L9.99844 12.0541L17.5193 19.575C18.0859 20.1416 19.0045 20.1416 19.5711 19.575Z"
        fill="url(#paint0_linear_19043_1521)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_19043_1521"
          x1="9.99843"
          y1="0"
          x2="9.99843"
          y2="20"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#88E5DC" />
          <stop offset="1" stopColor="#1DCDC3" />
        </linearGradient>
      </defs>
    </svg>
  );
};
